<template>
	<div>
		<h1 class="section-title">Edición de Perfil</h1>

		<b-card class="account-card mb-4">
			<template #header>
				<div>
					<h3 class="card-heading mb-1">Información Personal</h3>
					<p class="card-subheading mb-0">Actualiza tu información personal y preferencias</p>
				</div>
			</template>

			<b-form @submit.prevent>
				<div class="row">
					<div class="col-md-6 mb-3">
						<label class="field-label">Nombre completo</label>
						<b-form-input v-model="userName"></b-form-input>
					</div>
					<div class="col-md-6 mb-3">
						<label class="field-label">Correo electrónico</label>
						<b-form-input v-model="userEmail" type="email"></b-form-input>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6 mb-3">
						<label class="field-label">Teléfono</label>
						<div class="input-with-icon">
							<i class="fa-regular fa-phone input-icon"></i>
							<b-form-input v-model="userPhone"></b-form-input>
						</div>
					</div>
					<div class="col-md-6 mb-3">
						<label class="field-label">Fecha de Nacimiento</label>
						<div class="input-with-icon">
							<i class="fa-regular fa-calendar input-icon"></i>
							<b-form-input v-model="userDateOfBirth"></b-form-input>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6 mb-3">
						<label class="field-label">Ciudad</label>
						<div class="input-with-icon">
							<i class="fa-regular fa-location-dot input-icon"></i>
							<b-form-input v-model="userCity"></b-form-input>
						</div>
					</div>
					<div class="col-md-6 mb-3">
						<label class="field-label">Ocupación</label>
						<div class="input-with-icon">
							<i class="fa-regular fa-briefcase input-icon"></i>
							<b-form-input v-model="userOccupation"></b-form-input>
						</div>
					</div>
				</div>

				<div class="mb-4">
					<label class="field-label">Dirección completa</label>
					<div class="input-with-icon">
						<i class="fa-regular fa-building input-icon"></i>
						<b-form-input v-model="userAddress"></b-form-input>
					</div>
				</div>

				<b-button variant="info" block>
					<i class="fa-regular fa-pen-to-square mr-2"></i>
					Guardar Cambios
				</b-button>
			</b-form>
		</b-card>

		<!-- <b-card class="account-card">
			<template #header>
				<h3 class="card-heading mb-0">Preferencias de Cuenta</h3>
			</template>

			<div class="mb-3">
				<label class="field-label">Idioma preferido</label>
				<b-form-select v-model="preferredLanguage" :options="languageOptions"></b-form-select>
			</div>

			<div>
				<label class="field-label">Notificaciones</label>
				<b-form-checkbox v-model="notifyEmail" class="mb-2">
					Recibir notificaciones por correo
				</b-form-checkbox>
				<b-form-checkbox v-model="notifyCases" class="mb-2">
					Recibir actualizaciones de casos
				</b-form-checkbox>
				<b-form-checkbox v-model="notifyPromo">
					Recibir promociones y novedades
				</b-form-checkbox>
			</div>
		</b-card> -->
	</div>
</template>

<script>
export default {
	name: 'MyAccountMyData',

	data() {
		return {
			userName: '',
			userEmail: '',
			userPhone: '+52 55 1234 5678',
			userCity: 'Ciudad de México',
			userDateOfBirth: '15/03/1985',
			userOccupation: 'Empresario',
			userAddress: 'Av. Reforma 123, Col. Centro, CP 06000',
			preferredLanguage: 'es',
			languageOptions: [
				{ value: 'es', text: 'Español' },
				{ value: 'en', text: 'English' },
			],
			notifyEmail: true,
			notifyCases: true,
			notifyPromo: false,
		}
	},

	created() {
		this.userName = localStorage.getItem('userName') || 'Usuario'
		this.userEmail = localStorage.getItem('userEmail') || 'usuario@ejemplo.com'
	},
}
</script>
